<template>
  <div class="min-h-screen bg-gray-950 flex items-center justify-center p-6">
    <div class="max-w-sm w-full flex flex-col items-center gap-4 text-center">
      <TwitchIcon class="w-10 h-10" style="color:#BF94FF" />
      <p v-if="!error" class="text-text-primary">{{ $t('play.lan_party.twitch_linking') }}</p>
      <template v-else>
        <p class="text-text-primary">{{ error }}</p>
        <router-link
          :to="signedOut ? { name: 'Login' } : back"
          class="text-sm text-text-secondary hover:text-text-primary underline"
        >
          {{ signedOut ? $t('play.lan_party.log_in') : $t('play.lan_party.twitch_back') }}
        </router-link>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import axios from 'axios';
import { useI18n } from 'vue-i18n';
// eslint-disable-next-line import-x/extensions
import { useAuth } from '@websanova/vue-auth/src/v3.js';
import TwitchIcon from '../components/LanParty/TwitchIcon.vue';
import { apiError, takeTwitchReturn } from '../utils/lan_party';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const auth = useAuth();
const store = useStore();
const error = ref('');
const back = takeTwitchReturn();
const signedOut = !auth.check();

onMounted(() => {
  if (signedOut) {
    error.value = t('play.lan_party.twitch_signed_out');
    return;
  }
  const { code, state, error: twitchError } = route.query;
  if (!code || !state) {
    // access_denied is the user saying no. Only the bare error code is shown, never Twitch's
    // description: anyone can put text in this URL.
    const reason = /^[a-z_]{1,40}$/.test(twitchError || '') ? twitchError : null;
    error.value = !reason || reason === 'access_denied'
      ? t('play.lan_party.twitch_cancelled')
      : t('play.lan_party.twitch_refused', { reason });
    return;
  }
  axios.post('/twitch/link', { code, state })
    .then(({ data }) => {
      store.commit('showMessage', {
        messageType: 'success',
        messageText: data.kind === 'creator'
          ? t('play.lan_party.twitch_channel_connected')
          : t('play.lan_party.twitch_linked_toast', { login: data.twitch?.login }),
      });
      return auth.fetch().catch(() => {});
    })
    .then(() => router.replace(back))
    .catch((e) => { error.value = apiError(e, t('play.lan_party.twitch_failed')); });
});
</script>
